<template>
	<div class="modal" data-backdrop="static" id="minutes-task-modal" tabindex="-1" role="dialog" aria-labelledby="myModalOptionLabel">
		<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
			<div class="modal-content" style="margin-bottom:5rem;">
				<div class="modal-header">
					<h5 class="modal-title" id="myModalOptionLabel">タスク作成</h5>
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
				</div>
				<div class="modal-body">
					<form action="#">
						<div class="form-group row">
							<label for="modal_taskname" class="col-sm-2 col-form-label">タスク名</label>
							<div class="col-sm-10 pl-1">
								<input type="text" name="modal_taskname" id="modal_taskname" class="form-control px-2" placeholder="タスク名の入力" autocomplete="off" style="width: -webkit-fill-available;">
							</div>
						</div>
						<div class="form-group row">
							<label for="taskDate" class="col-sm-2 col-form-label">期限</label>
							<div class="col-sm-4 pl-1 input-icon-calendar">
								<input type="text" id="taskDate" value="" class="form-control due-date px-2" autocomplete="off">
							</div>
						</div>
						<div class="form-group row">
							<label for="refDate" class="col-sm-2 col-form-label text-nowrap">マスタ参照日</label>
							<div class="col-sm-4 pl-1 input-icon-calendar">
								<input type="text" id="ref_date" value="" class="form-control ref-date px-2" autocomplete="off">
							</div>
						</div>
						<ul class="nav nav-tabs minutes-task-tab" role="tablist">
							<li class="nav-item"><a class="nav-link active" id="minutes-task-tab1" data-toggle="tab" href="#minutes-task-item1" role="tab" aria-controls="minutes-task-item1" aria-selected="true">部門</a></li>
							<li class="nav-item"><a class="nav-link" id="minutes-task-tab2" data-toggle="tab" href="#minutes-task-item2" role="tab" aria-controls="minutes-task-item2" aria-selected="false">人</a></li>
						</ul>
						<div class="row">
							<div class="col-lg-5">
								<div class="tab-content">
									<div class="tab-pane fade show active" id="minutes-task-item1" role="tabpanel" aria-labelledby="minutes-task-tab1">
										<input name="minutes_taskorginput" class="form-control committee-user-org" placeholder="部門検索" @input="input_change($event.target, 0)" autocomplete="off"> <select name="minutes_taskorg" class="form-control modal-height select-target" multiple="multiple" target="#minutes_task_target_org"></select> <select id="minutes_taskorg-dummy" class="form-control" style="display: none;"></select>
									</div>
									<div class="tab-pane fade" id="minutes-task-item2" role="tabpanel" aria-labelledby="minutes-task-tab2">
										<input name="minutes_taskpersoninput" class="form-control committee-user-org" placeholder="ユーザー検索" @input="input_change($event.target, 0)" autocomplete="off"> <select name="minutes_taskperson" class="form-control modal-height select-target" multiple="multiple" target="#minutes_task_target_person"></select> <select id="minutes_taskperson-dummy" class="form-control" style="display: none;"></select>
									</div>
									<div class="tab-pane fade" id="minutes-task-item3" role="tabpanel" aria-labelledby="minutes-task-tab3">
										<select name="minutes_taskgroup" class="form-control modal-height" multiple="multiple" target="#minutes_task_target_group"></select>
									</div>
								</div>
							</div>
							<div class="col-lg-1 p-0">
								<div class="row h-50 align-items-center">
									<div class="col-12">
										<button type="button" class="minutes_task_append btn btn-primary">
											<i class="bi bi-arrow-right"></i>
										</button>
									</div>
								</div>
								<div class="row h-50 align-items-center">
									<div class="col-12">
										<button type="button" class="minutes_task_delete btn btn-primary">
											<i class="bi bi-arrow-left"></i>
										</button>
									</div>
								</div>
							</div>
							<div class="col-lg-6">
								<p class="w-100">対象</p>
								<select id="minutes_task_target_list" name="minutes_task_target_list" class="form-control modal-height" multiple="multiple">
									<optgroup id="minutes_task_target_org" label="部門"></optgroup>
									<optgroup id="minutes_task_target_person" label="人"></optgroup>
								</select>
							</div>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<input type="text" name="dummytext" class="p-0" style="border: 0px; width: 0px;">
					<button type="button" class="btn btn-primary" name="minutes-btn-save">決定</button>
					<button type="button" class="btn btn-primary" name="minutes-btn-delete">削除</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";
import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';
import config from "@/config";

datepickerFactory($);
datepickerJAFactory($);

export default {
	props: {
		csfr: String,
	},
	data: () => ({
		
	}),
	
	created() {
		
	},
	
	methods: {
		getAttendList() {
			const $speakerlist = [];
			if ($(".PersonList .PersonBlock").length) {
				$.each($(".PersonList .PersonBlock"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.find(".Person").text()};
					$speakerlist.push($users);
				});
				$.each($(".GuestPersonList .GuestPersonBlock"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.find(".GuestPerson").text()};
					$speakerlist.push($users);
				});
			} else if ($("#attend_other .Person").length) {
				$.each($("#attend_other .Person"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.text()};
					$speakerlist.push($users);
				});
				$.each($("#attend_other_guest .GuestPerson"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.text()};
					$speakerlist.push($users);
				});
			}
			return $speakerlist;
		},
		
		escapeHTML(val) {
			if(!isNaN(val)){
				return val;
			} else if(val == null){
				return "";
			} else {
				return val
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, "&#x27;");
			}
		},
		
		escapeSelectorString(val){
			if(!isNaN(val)){
				return val;
			} else {
				return val.replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, "\\$&");
			}
		},
		
		parseStrToBoolean(str) {
			// 文字列を判定
			return (str == 'true') ? true : false;
		},
		
		getCommaToList(str) {
			return str.split(',');
		},
		
		getListToComma(list) {
			const $arrays = [];
			$.each($(list),function(i,elem) {
				if(typeof elem== "string") {
					$arrays.push(elem);
				} else {
					$arrays.push($(elem).val());
				}
			});
			return $arrays.join(',');
		},
		
		nullToEmpty(str) {
			return (str == null) ? "" : str;
		},
		
		// 社員組織設定モーダルの入力フォームの値と部分一致する項目をセレクトボックスに表示させる
		input_change(target, num) {
			// 対象のセレクトボックス
			const $target_select = $(target).parent().children().eq(num+1);
			// 値保持用セレクトボックス
			const $cache_select = $(target).parent().children().eq(num+2);
			// セレクトボックス初期化
			$target_select.children().remove();

			// 入力値を大文字小文字に変換
			var input_upper_char = target.value.toUpperCase();
			var input_lower_char = target.value.toLowerCase();
			var val_li = [];
			var text_li = [];
			var name_li = [];

			// 入力値に部分一致する項目を検索し、保持
			$cache_select.children().each(function(i, elem){
				var select_val = $(elem).val();
				var select_text = $(elem).text();
				var select_name = "";
				if ($(elem).attr("uName") != undefined) {
					select_name = $(elem).attr("uName");
				} else if ($(elem).attr("user_name") != undefined) {
					select_name = $(elem).attr("user_name");
				}


				if (input_lower_char != "") {
					if (select_text.indexOf(input_upper_char) > -1 || select_text.indexOf(input_lower_char) > -1) {
						val_li.push(select_val);
						text_li.push(select_text);
						name_li.push(select_name);
					}
				} else {
					val_li.push(select_val);
					text_li.push(select_text);
					name_li.push(select_name);
				}
			});

			// 保持した値を設定
			var selected_option = "";
			for(let i=0; i<val_li.length; i++) {
				if (name_li.length > 0) {
					selected_option = selected_option + "<option user_name='" + this.escapeHTML(name_li[i]) + "' uName='" + this.escapeHTML(name_li[i]) + "' data-toggle='tooltip' title='"+  this.escapeHTML(text_li[i]) +"' value=" + this.escapeHTML(val_li[i]) + ">" + this.escapeHTML(text_li[i]) + "</option>";
				} else {
					selected_option = selected_option + "<option data-toggle='tooltip' title='"+  this.escapeHTML(text_li[i]) +"' value=" + this.escapeHTML(val_li[i]) + ">" + this.escapeHTML(text_li[i]) + "</option>";
				}
			}
			$target_select.append(selected_option);
		},
		
		getObjectID() {
			var S="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
			var N=31;
			return "O" + Array.from(crypto.getRandomValues(new Uint8Array(N))).map((n)=>S[n%S.length]).join('');
		},
		
		setDeptSelect(refDate) {
			const _self = this;
			// 各フィールドから値を取得してJSONデータを作成
			var data = {
				ref_date:refDate.val(),
			};
			
			const parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
			
			// 通信実行
			return $.ajax({
				type:'post',                // method = "POST"
				url:parenturl + 'getDeptList',        // POST送信先のURL
				data:JSON.stringify(data),  // JSONデータ本体
				contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
				dataType: 'json',           // レスポンスをJSONとしてパースする
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				headers: {
					'X-CSRF-TOKEN': _self.csfr,
				},
			}).done(function(data, dataType) {
				$('[name="minutes_taskorg"]').empty();
				$('#minutes_taskorg-dummy').empty();
				var dept_option = "";
				if(data.length) {
					if (data[0].error=="true") {
						_self.showNotUpdateMessage(data[0].message);
					} else {
						var delimiter = ","
						$.each(data,function(i,elem) {
							dept_option = dept_option + "<option title=" + "[" + _self.escapeHTML(elem["DEPT_CODE"]) + "]&nbsp;" + _self.escapeHTML(elem["DEPT_NAME"]) + " value=" + _self.escapeHTML(elem["DEPT_CODE"]) + delimiter + _self.escapeHTML(elem["DEPT_NAME"]) + delimiter + "true>" + "[" + _self.escapeHTML(elem["DEPT_CODE"]) + "]&nbsp;" + _self.escapeHTML(elem["DEPT_NAME"]) + "</option>";
						});
					}
				}
				$('[name="minutes_taskorg"]').append(dept_option);
				$('#minutes_taskorg-dummy').append(dept_option);
			}).fail(function(XMLHttpRequest, textStatus, errorThrown) {
			})
		},

		setUserSelect(agendaId) {	
			const _self = this;
			// 各フィールドから値を取得してJSONデータを作成
			var data = {
				ref_date:$("#ref_date").val(),
				agenda_id:agendaId,
			};
			
			const parenturl = config.VUE_APP_PARENT_URL.endsWith("/") ?  config.VUE_APP_PARENT_URL : config.VUE_APP_PARENT_URL + "/";
			
			// 通信実行
			return $.ajax({
				type:'post',                // method = "POST"
				url:parenturl + 'getUserListAll2',        // POST送信先のURL
				data:JSON.stringify(data),  // JSONデータ本体
				contentType: 'application/json; charset=UTF-8', // リクエストの Content-Type
				dataType: 'json',           // レスポンスをJSONとしてパースする
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				headers: {
					'X-CSRF-TOKEN': _self.csfr,
				},
			}).done(function(data, dataType) {
				$('[name="minutes_taskperson"]').empty();
				$('#minutes_taskperson-dummy').empty();
				var user_option = "";
				if(data.length) {
					if (data[0].error=="true") {
						_self.showNotUpdateMessage(data[0].message);
					} else {
						var delimiter = ","
						$.each(data,function(i,elem) {
							user_option = user_option + "<option title=" + "[" + _self.escapeHTML(elem["TARGET_CODE"]) + "]&nbsp;" + _self.escapeHTML(elem["USER_NAME"]) + " value=" + _self.escapeHTML(elem["TARGET_CODE"]) + delimiter + _self.escapeHTML(elem["USER_NAME"])  + delimiter + "true>" + "[" + _self.escapeHTML(elem["TARGET_CODE"]) + "]&nbsp;" + _self.escapeHTML(elem["USER_NAME"]) + "</option>";
						});
					}
				}
				$('[name="minutes_taskperson"]').append(user_option);
				$('#minutes_taskperson-dummy').append(user_option);
			}).fail(function(XMLHttpRequest,textStatus,errorThrown) {
			})
		},
		
		clearDatepicker(e) {
			if ($(e.target).val() != '') {
				var inputDate = new Date($(e.target).val());
				if (isNaN(inputDate.getTime())) {
					$(e.target).val('')	.change();
				}
			}
		},
		
		showNotUpdateMessage(data) {
			$('#SaveButtonAlert').css("display", "none");
			if(data != undefined) {
				if($.isPlainObject(data)) {
					$("#error_alert_message").text(data["message"]);
				} else {
					// console.log(data)
					if (Array.isArray(data)) {
						if ($(".insert_message").length) {
							$(".insert_message").remove();
						}
						$("#error_alert_message").css("display","none");
						data.forEach(function(element){
							let $span_message = $("#error_alert_message").clone(false);
							$span_message.addClass("insert_message").css("display","block");
							$("#SaveButtonAlert2").append($span_message.text(element.message));
						});
					} else {
						$("#error_alert_message").text(data);
					}
				}
			} else {
				$("#error_alert_message").text("予期しないエラーが発生しました");
			}
		
			$('#SaveButtonAlert2').fadeIn("fast", function () {
			});
		},
	},
	
	mounted() {
		const _self = this;
		
		$("#minutes-task-modal").on("show.bs.modal", function(e) {
			const $modal = $("#minutes-task-modal");
			$modal.find('[name="minutes_taskperson"] option').remove();
			$modal.find("#minutes_taskperson-dummy option").remove();
			var attendList = _self.getAttendList();
			var user_option = '';
			var user_len = attendList.length;
			const params = (new URL(document.location)).searchParams;
			for(let i=0; i<user_len; i++) {
				if (!attendList[i]["USER_ID"].startsWith("guest")) {
					user_option = user_option + "<option title=" + _self.escapeHTML(attendList[i]["USER_NAME"]) + " value=" + _self.escapeHTML(attendList[i]["USER_ID"]) + "," + _self.escapeHTML(attendList[i]["USER_NAME"]) + ">" + "[" + _self.escapeHTML(attendList[i]["USER_ID"]) + "] " + _self.escapeHTML(attendList[i]["USER_NAME"]) + "</option>";
				}
			}
			$modal.find('[name="minutes_taskperson"]').append(user_option)
			$modal.find("#minutes_taskperson-dummy").append(user_option);
			$("#minutes_task_target_list #minutes_task_target_org option").remove();
			$("#minutes_task_target_list #minutes_task_target_person option").remove();
			$("#minutes_task_target_list #minutes_task_target_group option").remove();
			const $taskarea = $("#" + _self.escapeSelectorString($(".minutes-active").attr("id"))).closest("tr").find(".dummy-tag-area .task-area p[target='" + _self.escapeSelectorString($(".minutes-active").attr("id"))+"']");
			if($taskarea.length) {
				const $org = _self.getCommaToList($taskarea.attr("taskorg"));
				const $orgname = _self.getCommaToList($taskarea.attr("taskorgname"));
				const $orgflag = _self.getCommaToList($taskarea.attr("taskorgflag"));
				console.log($orgflag)
				const $person = _self.getCommaToList($taskarea.attr("taskperson"));
				const $personname = _self.getCommaToList($taskarea.attr("taskpersonname"));
				const $personflag = _self.getCommaToList($taskarea.attr("taskpersonflag"));
				var taskname = "";
				var $target = $(".minutes-active");
				var $textarea = $target.closest(".minutes_manager_area").find(".minutes_manager")
				if (_self.parseStrToBoolean($taskarea.find(".disp-title-task").attr("saveFlag"))) {
					if (_self.parseStrToBoolean($taskarea.find(".disp-title-task").attr("nameFlag"))) {
						taskname = $taskarea.find(".disp-title-task").text();
					} else {
						taskname = $textarea.val();
					}
				} else {
					taskname = $textarea.val();
				}
				$modal.find("#modal_taskname").val(taskname);
				$modal.find("#taskDate").val($taskarea.find(".task_date").text());    
				$.each($org,function(i,elem) {
					if(_self.nullToEmpty(elem) == "") {
						return;
					}
					const $select = $("#minutes-task-item1 [name='minutes_taskorg']");
					$target = $($select.attr("target"));
					var orgOption ="<option title=[" + _self.escapeSelectorString(elem) + "]&nbsp;" + ($orgname[i]) + " value=" + _self.escapeSelectorString(elem) + "," + ($orgname[i]) + "," +  ($orgflag[i]) + " flag=" + ($orgflag[i]) + ">" + "[" + _self.escapeSelectorString(elem) + "]&nbsp;" + ($orgname[i]) + "</option>";
					$target.append(orgOption);
				});

				$.each($person,function(i,elem) {
					if(_self.nullToEmpty(elem) == "") {
						return;
					}
					const $select = $("#minutes-task-item2 [name='minutes_taskperson']");
					$target = $($select.attr("target"));
					var userOption = "<option title=[" + _self.escapeSelectorString(elem) + "]&nbsp;" + _self.escapeSelectorString($personname[i]) + " value=" + _self.escapeSelectorString(elem) + "," + _self.escapeSelectorString($personname[i]) + "," + ($personflag[i]) + " flag=" + ($personflag[i]) + ">" + "[" + _self.escapeSelectorString(elem) + "]&nbsp;" + _self.escapeSelectorString($personname[i]) + "</option>";
					$target.append(userOption);
				});

				$("#minutes-task-modal button[name='minutes-btn-save']").css("display", "block").text("保存");
				$("#minutes-task-modal button[name='minutes-btn-delete']").css("display", "block");
			} else {
				$("#minutes-task-modal button[name='minutes-btn-save']").css("display", "block").text("保存");
				$("#minutes-task-modal button[name='minutes-btn-delete']").css("display", "none");
			}
			_self.setDeptSelect($("#ref_date").val($("#meetDate").val()));
			_self.setUserSelect(params.get('roomId'));
		});
		
		$("#minutes-task-modal").on("hidden.bs.modal", function(e) {
			$(".minutes-active").focus();
		});
		
		$("#minutes-task-modal button[name='minutes-btn-save']").on("click", function(e) {

			var $textarea = $(".minutes-active").closest("tr").find(".minutes_manager");
			var agenda_detail_id = $textarea.attr("agenda_detail_id");
			var minutes_id = $textarea.attr("id");
			var target =  $textarea.attr("judge_minutes");
			var task_id = $(".minutes-active").closest("tr").find("span.additional-info-task").find("i").attr("taskid");
			var taskName = $("#modal_taskname").val();
			var saveFg = true;
			var nameFg = true;
			var insertFg = true;
			var taskDate = $("#taskDate").val();
			if (taskName == "") {
				taskName = $textarea.val();
				nameFg = false;
			}
			
			const $org = $("#minutes_task_target_list #minutes_task_target_org option");
			var orgcode = [];
			var orgname = [];
			var orgflag = [];
			$.each($org,function(i,elem) {
				var org = _self.getCommaToList(elem.value);
				orgcode.push(org[0]);
				orgname.push(org[1]);
				orgflag.push(org[2]);
			});
			const $person = $("#minutes_task_target_list #minutes_task_target_person option");
			var personid = [];
			var personname = [];
			var personflag = [];
			$.each($person, function(i,elem) {
				var person = _self.getCommaToList(elem.value);
				personid.push(person[0]);
				personname.push(person[1]);
				personflag.push(person[2]);
			});

			_self.$emit('domergetask', target, agenda_detail_id, minutes_id, task_id, orgcode, orgname, orgflag, personid, personname, personflag, [], nameFg, saveFg, insertFg, taskName, taskDate);
			$("#minutes-task-modal").modal("hide");
		});
		
		$("#minutes-task-modal").on("shown.bs.modal", function(e) {
			const $modal = $("#minutes-task-modal");
			$modal.find('[name="dummytext"]').focus();

			setTimeout(function(){ 
				$modal.find('[name="modal_taskname"]').focus();
			},50);
		});
		
		$("#minutes-task-modal button[name='minutes-btn-delete']").on("click", function(e) {
			const $task = $(".minutes-active").closest("tr").find(".table-tag-area .additional-info-task i");
			const $task_id = $task.attr("taskid");
			const $target_p = $("[taskid="+$task_id+"]");
			if ($(".minutes-active").closest("tr").find("span.disp-title-task").attr("saveflag") == "true") {
				if (!window.confirm("タスクを削除しますか？")) {
					return;
				}	
			}
								
			var $textarea = $(".minutes-active").closest("tr").find(".minutes_manager");
			var agenda_detail_id = $textarea.attr("agenda_detail_id");
			var minutes_id = $textarea.attr("id");
			var target =  $textarea.attr("judge_minutes");

			_self.$emit('domergetask', target, agenda_detail_id, minutes_id, null, [], [], [], [], [], [], [], false, false, true, null, null);
			$("#minutes-task-modal").modal("hide");

		});
		
		$("#minutes-task-modal button.minutes_task_append").on("click", function(e) {
			const $active = $(".minutes-task-tab li a.active");
			const $select = $( $active.attr("href") + " .select-target");
			const $target = $($select.attr("target"));
			var targetIdList = [];
			$.each($target.find("option"),function(i,elem){
				var temp = $target.find("option")[i].value;
				targetIdList.push(_self.getCommaToList(temp)[0]);
			}); 
			var option = "";

			$.each($select.find("option:selected"),function(i,elem) {
				var valList = _self.getCommaToList($(elem).val());
				if (!targetIdList.includes(valList[0])) {
					option = option + "<option title=" + _self.escapeHTML($(elem).text()) +" value=" + _self.escapeHTML($(elem).val()) + " flag=true>" + _self.escapeHTML($(elem).text()) + "</option>";
				}
			});

			$target.append(option);
			var select = $select.prev();
			select[0].value = "";
			_self.input_change(select[0], 0);
		});
		
		$("#minutes-task-modal button.minutes_task_delete").on("click", function(e) {
			$.each($("#minutes_task_target_list option:selected"),function(i,elem) {
				$(elem).remove();
			});
		});
		
		$("#minutes-task-modal select[name='minutes_taskorg'],select[name='minutes_taskperson']").on("dblclick", function(e) {
			$("#minutes-task-modal button.minutes_task_append").trigger("click");
		});

		$("#minutes-task-modal #minutes_task_target_list").on("dblclick", function(e) {
			$("#minutes-task-modal button.minutes_task_delete").trigger("click");
		});
		
		$(document).on('change', '#ref_date', function() {
			_self.setDeptSelect($("#ref_date"));
			const params = (new URL(document.location)).searchParams;
			_self.setUserSelect (params.get('roomId'));
		});
		
		$(function() {
			$(".due-date").datepicker({}).on('blur', function(e) {
				_self.clearDatepicker(e);
			});
			
			$(".ref-date").datepicker({}).on('blur', function(e) {
				_self.clearDatepicker(e);
			});
		});
		
		$(document).on('click','#SaveButtonAlertContent2', function() {
			$('#SaveButtonAlert2').css("display", "none");
		});
	}
}
</script>
<style>
.speaker-btn-area {
	display: flex;
	justify-content: end;
}

.speaker-btn-area button {
	font-size: 12px;
	height: fit-content;
}
</style>